import React from 'react';
import { BaseFilterProps } from '../../../common/BaseFilter';
import { DateTimeFilter } from '../../../DateTimeFilter';
import { FilterProps } from '../../../common/filter.util';
import { AssetCreatedAtFilterContent } from './Content/AssetCreatedAtFilterContent';

export class AssetCreatedAtFilter extends DateTimeFilter {
  toComponent(props: BaseFilterProps): React.JSX.Element {
    return <AssetCreatedAtFilterContent props={props} />;
  }

  static filter(filterProps: FilterProps, item?: Date) {
    if (!item) return true;
    if (!filterProps.assetCreatedAt) return true;
    return item >= new Date(filterProps.assetCreatedAt.start) && item <= new Date(filterProps.assetCreatedAt.end);
  }
}
